import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileBusinesses = {
  dashboard: async(props) => {
    const { default: DashboardIndex } = await import('@/vue_widgets/geobooster/dashboard/index.vue')
    createVueApp(DashboardIndex, { props, sidebar })
  }
}
